export class Timing {
  public static sleep(ms: number): Promise<boolean> {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
